const boardSubjectsMap = {
  /* ===================== NATIONAL BOARDS ===================== */

  CBSE: [
    "English",
    "Hindi",
    "Other Language",
    "Mathematics (Basic)",
    "Mathematics (Standard)",
    "Science (Physics)",
    "Science (Chemistry)",
    "Science (Biology)",
    "Social Science",
    "Artificial Intelligence",
    "Computer Science",
    "Information Technology",
    "Physical Education",
    "NCC",
    "Art",
    "Music",
    "Home Science",
    "Business Studies",
    "Agriculture",
    "Others",
  ],

  "CISCE (ICSE/ISC)": [
    "English",
    "Second Language",
    "History",
    "Civics",
    "Geography",
    "Mathematics",
    "Science",
    "Economics",
    "Computer Applications",
    "Art",
    "Music",
    "Performing Arts",
    "Vocational Subjects",
    "Others",
  ],

  NIOS: [
    "English",
    "Hindi",
    "Other Language",
    "Mathematics",
    "Science",
    "Social Science",
    "Computer Science",
    "Business Studies",
    "Home Science",
    "Information Technology",
    "Health & Nutrition",
    "Fashion Design",
    "Vocational Subjects",
    "Others",
  ],

  /* ===================== INTERNATIONAL BOARDS ===================== */

  "CAIE (IGCSE / AS & A Levels)": [
    "Languages",
    "Mathematics",
    "Sciences",
    "Humanities",
    "Art",
    "ICT",
    "Marine Science",
    "Travel & Tourism",
    "Professional Subjects",
    "Others",
  ],

  "IB (MYP / DP)": [
    "Language & Literature",
    "Language Acquisition",
    "Sciences",
    "Individuals & Societies",
    "Mathematics",
    "Arts",
    "Design",
    "Physical & Health Education",
    "Others",
  ],

  /* ===================== STATE BOARDS ===================== */

  "Andhra Pradesh - BSEAP": [
    "English",
    "Hindi",
    "Mathematics",
    "General Science",
    "Social Science",
    "Civics",
    "Consumer Awareness",
    "Economic Systems",
    "Others",
  ],

  "Assam - AHSEC": [
    "English",
    "Assamese",
    "Hindi",
    "Mathematics",
    "Science",
    "Social Science",
    "Sanskrit",
    "Arabic",
    "Persian",
    "Others",
  ],

  "Bihar - BSEB": [
    "English",
    "Hindi",
    "Urdu",
    "Sanskrit",
    "Mathematics",
    "Science",
    "Social Science",
    "Disaster Management",
    "Others",
  ],

  "Chhattisgarh - CGBSE": [
    "English",
    "Hindi",
    "Mathematics",
    "Science",
    "Social Science",
    "Skill-Based Electives",
    "Others",
  ],

  "Goa - GBSHSE": [
    "English",
    "Marathi",
    "Konkani",
    "Hindi",
    "Mathematics",
    "Science",
    "Social Science",
    "Computer Science",
    "Art",
    "Music",
    "Others",
  ],

  "Gujarat - GSEB": [
    "English",
    "Gujarati",
    "Hindi",
    "Mathematics",
    "Science",
    "Social Science",
    "Art",
    "Music",
    "Physical Education",
    "Yoga",
    "Others",
  ],

  "Haryana - HBSE": [
    "English",
    "Hindi",
    "Punjabi",
    "Mathematics",
    "Science",
    "Social Science",
    "Sanskrit",
    "Computer Science",
    "Art",
    "Home Science",
    "Others",
  ],

  "Jammu & Kashmir - JKBOSE": [
    "English",
    "Urdu",
    "Hindi",
    "Mathematics",
    "Science",
    "Social Science",
    "Kashmiri",
    "Vocational Electives",
    "Others",
  ],

  "Jharkhand - JAC": [
    "English",
    "Hindi",
    "Mathematics",
    "Science",
    "Social Science",
    "Others",
  ],

  "Karnataka - KSEEB/KSEAB (PUC)": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Sociology",
    "Business Studies",
    "Economics",
    "Political Science",
    "Others",
  ],

  "Kerala - KBPE (Plus One/Plus Two)": [
    "English",
    "Hindi",
    "Malayalam",
    "Sanskrit",
    "Mathematics",
    "Science",
    "Social Science",
    "Others",
  ],

  "Madhya Pradesh - MPBSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Science Stream",
    "Commerce Stream",
    "Agriculture Stream",
    "Technical Stream",
    "NCC",
    "Physical Education",
    "SUPW",
    "Others",
  ],

  "Maharashtra - MSBSHSE": [
    "English",
    "Marathi",
    "Mathematics",
    "Science",
    "Social Science",
    "Third Language",
    "Information Technology",
    "Internal Assessments",
    "Others",
  ],

  "Manipur - BSEM": [
    "English",
    "Manipuri",
    "Hindi",
    "Mathematics",
    "Science",
    "Social Science",
    "Information Technology",
    "Moral Education",
    "Others",
  ],

  "Meghalaya - MBOSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Computer Science",
    "Art",
    "Craft",
    "Gardening",
    "Electrical Gadgets",
    "Others",
  ],

  "Mizoram - MBSE": [
    "English",
    "Hindi",
    "Mizo",
    "Mathematics",
    "Science",
    "Social Science",
    "Others",
  ],

  "Nagaland - NBSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Environmental Education",
    "Bookkeeping",
    "Others",
  ],

  "Odisha - BSE Odisha (CHSE)": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Others",
  ],

  "Punjab - PSEB": [
    "Punjabi",
    "Hindi",
    "Urdu",
    "English",
    "Mathematics",
    "Science",
    "Social Science",
    "Computer Science",
    "NSQF Trades",
    "Agriculture",
    "Home Science",
    "Others",
  ],

  "Rajasthan - RBSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Information Technology",
    "Electives",
    "Others",
  ],

  "Sikkim - SBSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Others",
  ],

  "Tamil Nadu - TNBSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Computer Science",
    "Vocational Subjects",
    "Others",
  ],

  "Telangana - BSET": [
    "Languages",
    "Mathematics",
    "Physical Science",
    "Biological Science",
    "Social Science",
    "Others",
  ],

  "Tripura - TBSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Information Technology",
    "Tourism",
    "Automotive",
    "Vocational Streams",
    "Others",
  ],

  "Uttar Pradesh - UPMSP": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Commerce",
    "Agriculture",
    "Drawing",
    "Computer Science",
    "NCC",
    "Physical Education",
    "Others",
  ],

  "Uttarakhand - UBSE": [
    "Languages",
    "Mathematics",
    "Science",
    "Social Science",
    "Computer Science",
    "Others",
  ],

  "West Bengal - WBBSE (WBCHSE)": [
    "Languages",
    "Mathematics",
    "History",
    "Geography",
    "Physical Science",
    "Life Science",
    "Others",
  ],
};

const schoolBoards = [
  // National Boards
  "CBSE",
  "CISCE (ICSE/ISC)",
  "NIOS",

  // International Boards
  "CAIE (IGCSE / AS & A Levels)",
  "IB (MYP / DP)",

  // State Boards (India)
  "Andhra Pradesh - BSEAP",
  "Assam - AHSEC",
  "Bihar - BSEB",
  "Chhattisgarh - CGBSE",
  "Goa - GBSHSE",
  "Gujarat - GSEB",
  "Haryana - HBSE",
  "State Board – Himachal Pradesh",
  "Jharkhand - JAC",
  "Karnataka - KSEEB/KSEAB (PUC)",
  "Kerala - KBPE (Plus One/Plus Two)",
  "Madhya Pradesh - MPBSE",
  "Maharashtra - MSBSHSE",
  "Manipur - BSEM",
  "Meghalaya - MBOSE",
  "Mizoram - MBSE",
  "Nagaland - NBSE",
  "Odisha - BSE Odisha (CHSE)",
  "Punjab - PSEB",
  "Rajasthan - RBSE",
  "Sikkim - SBSE",
  "Tamil Nadu - TNBSE",
  "Telangana - BSET",
  "Tripura - TBSE",
  "Uttar Pradesh - UPMSP",
  "Uttarakhand - UBSE",
  "West Bengal - WBBSE (WBCHSE)",
  "Jammu & Kashmir - JKBOSE",
];

export { boardSubjectsMap, schoolBoards };
